import './bootstrap';

import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import { InertiaProgress } from '@inertiajs/progress'
import VueTelInput from 'vue3-tel-input'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue3-tel-input/dist/vue3-tel-input.css'

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

const VueTelInputOptions = {
    mode: "national",
    autoFormat:false,
    validCharactersOnly: true,
    inputOptions: {
        placeholder : "XXXXXXXXXX"
    },
    dropdownOptions: {
        showDialCodeInSelection: true
    }
}

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Front/${name}.vue`),
    setup({ el, app, props, plugin }) {
        return createApp({ render: () => h(app, props) })
            .use(plugin)
            .use(VueSweetalert2)
            .use(VueTelInput, VueTelInputOptions)
            .mixin({ methods: { route } })
            .mount(el);
    },
});

InertiaProgress.init({ color: '#1875ff' });
